/* Product card media carousel (collection grid) */
(function () {
  if (customElements.get('product-card-carousel')) {
    return;
  }

  class ProductCardCarousel extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('[data-carousel-track]');

      if (!this._track) {
        return;
      }

      this._slides = Array.prototype.slice.call(this._track.children);
      this._dots = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-dot]'));
      this._prevArrow = this.querySelector('[data-carousel-arrow="-1"]');
      this._nextArrow = this.querySelector('[data-carousel-arrow="1"]');
      this._index = 0;
      this._raf = null;

      this._onScroll = this._onScroll.bind(this);
      this._track.addEventListener('scroll', this._onScroll, { passive: true });

      this._dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(i);
        }.bind(this));
      }, this);

      [this._prevArrow, this._nextArrow].forEach(function (arrow) {
        if (!arrow) {
          return;
        }

        arrow.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(this._index + parseInt(arrow.getAttribute('data-carousel-arrow'), 10));
        }.bind(this));
      }, this);

      this._update();
    }

    disconnectedCallback() {
      if (this._track) {
        this._track.removeEventListener('scroll', this._onScroll);
      }
    }

    goTo(index) {
      var clamped = Math.max(0, Math.min(this._slides.length - 1, index));
      this._track.scrollTo({ left: clamped * this._track.clientWidth, behavior: 'smooth' });
    }

    _onScroll() {
      if (this._raf) {
        return;
      }

      this._raf = requestAnimationFrame(function () {
        this._raf = null;
        this._update();
      }.bind(this));
    }

    _update() {
      var width = this._track.clientWidth || 1;
      this._index = Math.max(0, Math.min(this._slides.length - 1, Math.round(this._track.scrollLeft / width)));

      this._dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === this._index ? 'true' : 'false');
      }, this);

      if (this._prevArrow) {
        this._prevArrow.toggleAttribute('disabled', this._index === 0);
      }

      if (this._nextArrow) {
        this._nextArrow.toggleAttribute('disabled', this._index === this._slides.length - 1);
      }
    }
  }

  customElements.define('product-card-carousel', ProductCardCarousel);
})();